<template>
	<component :is="tag">
		<slot></slot>
	</component>
</template>

<script>
export default {
	name: "j-box",
	props: {
		tag: {
			type: String,
			required: false,
			default: "div"
		}
	}
}
</script>
